import { OAUTH_TOKEN } from "../actions/types";
const initialState = {
  loginurl: "",
};

export default function(state = initialState, action) {
  switch (action.type) {
    case OAUTH_TOKEN:
      return {
        ...state,
        loginurl: action.payload
      };
    default:
      return state;
  }
}